import React, { useState, useEffect } from "react";
import { BaseButtons } from "../../../../../../../../components/atoms";
import { BlackAndWhite } from "../../../../../../../../themes/Colors";
import { validate } from "uuid";

const RegisterListItem = ({
  item,
  onViewClick,
  setSelectedIndex,
  selectedIndex,
  index,
}) => {
  const [hover, setHover] = useState(false);
  const [viewData, setViewData] = useState(false);
  //   useEffect(() => {
  //     if (viewData && selectedIndex === index) {
  //       console.log("index checked", item);
  //       // here is where the approval fileds will be added for review
  //     } else {
  //       return;
  //     }
  //   }, [viewData]);
  return viewData && selectedIndex === index ? (
    <div
      style={{
        minHeight: 400,
        maxHeight: 400,
        height: 400,
        display: "flex",
        alignItems: "center",
        borderBottomStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#00000030",
        width: "100%",
        flexDirection: "column",
        backgroundColor: BlackAndWhite.secondary,
      }}
    >
      <div
        style={{
          minHeight: 40,
          display: "flex",
          alignItems: "center",
          borderBottomStyle: "solid",
          borderBottomWidth: 1,
          borderBottomColor: "#00000030",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#000000",
              fontSize: 14,
              width: "100%",
            }}
          >
            <div style={{ marginLeft: 15 }}>{item.userName}</div>
          </div>
        </div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#000000",
              fontSize: 14,
              width: "100%",
            }}
          >
            <div style={{ marginLeft: 15 }}>{Number(item.noOfPurchases)}</div>
          </div>
        </div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#000000",
              fontSize: 14,
              width: "100%",
            }}
          >
            <div style={{ marginLeft: 15 }}>
              R {Number(item.purchaseTotal).toFixed(2)}
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#000000",
              fontSize: 14,
              width: "100%",
            }}
          >
            <div style={{ marginLeft: 15 }}>
              R{" "}
              {(
                Number(item.purchaseTotal) / Number(item.noOfPurchases)
              ).toFixed(2)}
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BaseButtons
            mini={true}
            marginTopFalse={true}
            label={"CLOSE"}
            size={"100%"}
            onClick={() => {
              setViewData(false);
              setSelectedIndex(false);
            }}
          />
        </div>
      </div>
      <div
        style={{
          flex: 1,
          //   borderStyle: "solid",
          display: "flex",
          height: "100%",
          //   alignItems: "center",
          width: "100%",
          backgroundColor: "#00000010",
        }}
      >
        {/* patient info */}
        <div
          style={{
            minWidth: 200,
            flex: 0.3,

            height: "100%",
            backgroundColor: "#FFFFFF80",
          }}
        >
          <div style={{ marginLeft: 15, marginTop: 20, fontWeight: "bold" }}>
            PATIENT INFO
          </div>
          <div style={{ marginLeft: 15, marginTop: 10 }}>
            <div style={{ fontSize: 12, fontWeight: "bold", opacity: 0.7 }}>
              FREQUENTED / REGISTERED AT STORE
            </div>
            <div style={{ marginTop: 5 }}>
              {viewData && selectedIndex === index && item
                ? item.customerInfo.frequentedStore
                : "loading"}
            </div>
          </div>
          <div style={{ marginLeft: 15, marginTop: 10 }}>
            <div style={{ fontSize: 12, fontWeight: "bold", opacity: 0.7 }}>
              EMAIL
            </div>
            <div style={{ marginTop: 5 }}>
              {viewData && selectedIndex === index && item
                ? item.customerInfo.email
                : "loading"}
            </div>
          </div>
          <div style={{ marginLeft: 15, marginTop: 10 }}>
            <div style={{ fontSize: 12, fontWeight: "bold", opacity: 0.7 }}>
              CELL NUMBER
            </div>
            <div style={{ marginTop: 5 }}>
              {viewData && selectedIndex === index && item
                ? item.customerInfo.cellNumber
                : "loading"}
            </div>
          </div>
          <div style={{ marginLeft: 15, marginTop: 10 }}>
            <div style={{ fontSize: 12, fontWeight: "bold", opacity: 0.7 }}>
              ID NUMBER
            </div>
            <div style={{ marginTop: 5 }}>
              {viewData && selectedIndex === index && item
                ? item.customerInfo.idDoc
                : "loading"}
            </div>
          </div>
          <div style={{ marginLeft: 15, marginTop: 10 }}>
            <div style={{ fontSize: 12, fontWeight: "bold", opacity: 0.7 }}>
              DATE CREATED
            </div>
            <div style={{ marginTop: 5 }}>
              {viewData && selectedIndex === index && item
                ? item.customerInfo.dateCreated
                : "loading"}
            </div>
          </div>
        </div>
        <div
          style={{
            minWidth: 200,
            flex: 0.7,

            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: BlackAndWhite.primary,
              minHeight: 40,
              color: BlackAndWhite.secondary,
              display: "flex",
              alignItems: "center",
              fontSize: 12,
            }}
          >
            <div
              style={{
                flex: 0.2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              DATE
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              TIME
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              SLIP NO
            </div>

            <div
              style={{
                flex: 0.2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* DATE */}
            </div>
            <div
              style={{
                flex: 0.2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              TOTAL
            </div>
          </div>
          <div
            style={{
              flex: 1,
              overflowY: "scroll",
              overflowX: "hidden",

              display: "flex",
              flexDirection: "column",
              width: "100%",
              maxHeight: 310,
            }}
          >
            {item
              ? item.recieptArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        // backgroundColor: BlackAndWhite.primary,
                        minHeight: 40,
                        // color: BlackAndWhite.secondary,
                        display: "flex",
                        alignItems: "center",
                        fontSize: 12,
                      }}
                    >
                      <div
                        style={{
                          flex: 0.2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.dataItem.dateTime.substring(0, 10)}
                      </div>
                      <div
                        style={{
                          flex: 0.2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {new Date(item.dataItem.dateTime).toLocaleTimeString()}
                      </div>
                      <div
                        style={{
                          flex: 0.2,
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        {item.dataItem.slipNo}
                      </div>
                      {/* </div>
                      <div
                        style={{
                          flex: 0.2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                    
                      </div> */}
                      <div
                        style={{
                          flex: 0.2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.dataItem.storeName}
                      </div>
                      <div
                        style={{
                          flex: 0.2,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        R {Number(item.dataItem.total).toFixed(2)}
                      </div>
                    </div>
                  );
                })
              : "loading"}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      style={{
        minHeight: 40,
        display: "flex",
        alignItems: "center",
        borderBottomStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#00000030",
        width: "100%",
      }}
    >
      <div
        style={{
          flex: 0.2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#000000",
            fontSize: 14,
            width: "100%",
          }}
        >
          <div style={{ marginLeft: 15 }}>{item.userName}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#000000",
            fontSize: 14,
            width: "100%",
          }}
        >
          <div style={{ marginLeft: 15 }}>{Number(item.noOfPurchases)}</div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#000000",
            fontSize: 14,
            width: "100%",
          }}
        >
          <div style={{ marginLeft: 15 }}>
            R {Number(item.purchaseTotal).toFixed(2)}
          </div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#000000",
            fontSize: 14,
            width: "100%",
          }}
        >
          <div style={{ marginLeft: 15 }}>
            R{" "}
            {(Number(item.purchaseTotal) / Number(item.noOfPurchases)).toFixed(
              2
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BaseButtons
          mini={true}
          marginTopFalse={true}
          label={"VIEW"}
          size={"100%"}
          onClick={() => {
            setViewData(true);
            setSelectedIndex(index);
          }}
        />
      </div>
    </div>
  );
};

export default RegisterListItem;
